import logoSymbol from '../../../logo/logo-2026-divitta-simbolo-fundotransparente.png';

const LogoProfile = () => <img src={logoSymbol} alt="DiVitta" style={{ width: 32, height: 32, borderRadius: '50%', display: 'block' }} />;

export default LogoProfile;
